<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {
        Loading
    },
}
</script>

<template>
    <loading
     :is-full-page="true"
     :can-cancel="false"
     :active.sync="$root.loading"
     loader="dots"
     color="#00001a"
     :height="150"
     :width="150"
     background-color="#595959"
     >
    </loading>
</template>


